import { Button, Form, Input, message, Spin } from "antd";
import React, { useState, useMemo } from "react";
import { provisionDeviceAPI } from "../adminApi";
import "../css/UpdateMacPin.css";
import { serialNumberRegex } from "../const/regex";

const ProvisionDevice = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const showToast = ({ success, message: msg }) => {
    success ? message.success(msg, 3) : message.error(msg, 3);
  };

  const accessToken = useMemo(() => {
    return localStorage.getItem("access_token");
  }, []);

  const handleProvisionDevice = async (values) => {
    try {
      const { serial } = values;
      if (serial) {
        setLoading(true);
        const response = await provisionDeviceAPI(
          serial.trim(),
          `Bearer ${accessToken}`,
        );
        setLoading(false);
        showToast(response);
        if (response.success) form.resetFields();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error while provisioning device:", error.message);
      message.error("Error while provisioning device");
    }
  };

  if (loading) {
    return (
      <div className="outer-container">
        <div className="inner-container">
          <Spin size="large" className="loader" />
        </div>
      </div>
    );
  }
  return (
    <div className="outer-container">
      <div className="inner-container">
        <Form form={form} layout="vertical" onFinish={handleProvisionDevice}>
          <Form.Item
            label="Serial Number"
            name="serial"
            rules={[
              { required: true, message: "Serial Number is required" },
              {
                pattern: serialNumberRegex,
                message: "Incorrect input or Serial Numbers max limit exceeded",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Provision This Device
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ProvisionDevice;
